(function fileControllerDefinition() {
    'use strict';

    angular.module('File')
        .controller('FileDocumentSignController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'fileService', 'storageService', 'documentService', 'authExtend', 'alerts', '$window', 'profileCertificateService',
            function fileDocumentSignController($scope, config, $state, $translate, $stateParams, errors, fileService, storageService, documentService, authExtend, alerts, $window, profileCertificateService) {
                function detectIE() {
                    var ua = window.navigator.userAgent;

                    var msie = ua.indexOf('MSIE ');
                    if (msie > 0) {
                        // IE 10 or older => return version number
                        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                    }

                    var trident = ua.indexOf('Trident/');
                    if (trident > 0) {
                        // IE 11 => return version number
                        var rv = ua.indexOf('rv:');
                        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                    }

                    return false;
                };

                $scope.isDocumentLoaded = false;
                $scope.IsIe = detectIE();
                $scope.certificates = [];
                $scope.certificateSelected = {};

                $scope.openAccordion = function () {
                    $scope.accordionOpened = !$scope.accordionOpened;
                    $scope.file.accordionIsOpen = $scope.accordionOpened;

                    fileService.getSignatures($stateParams.file).then(function (result) {
                        $scope.file.signatures = result;
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.goBack();
                };

                $scope.getCertificate = function getCertificate() {

                    return profileCertificateService.get(authExtend.getOrganizationId(), true, 0, undefined).then(function (result) {
                        $scope.certificates = result;

                        if ($scope.certificates.length === 1) {
                            $scope.certificateSelected = $scope.certificates[0];
                        }
                        
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });                    
                }

                $scope.load = function () {
                    $scope.viewPdf();
                    $scope.getCertificate();
                }

                $scope.viewPdf = function () {                    
                    return fileService.getDocumentVersion($stateParams.id, $stateParams.version, false, $stateParams.file).then(function (result) {
                        if (result.base64File !== '') {
                            $scope.content = 'data:application/pdf;base64,' + result.base64File;
                            $scope.file = result;
                            $scope.isDocumentLoaded = true;
                            $scope.openAccordion();
                        }
                        else {
                            errors.showWarning('The document has no files');
                            $scope.cancel();
                        }
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError(error);
                        }
                        $scope.cancel();
                    });
                }

                $scope.sign = function () {
                    if (!$scope.fileSign.$valid) {
                        $scope.fileSign.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }
                    $translate(['Warning', 'CheckInCreateVersionConfirmText', 'Yes', 'No']).then(function (translated) {
                        if (authExtend.isInRole('DOCUMENTVERSION SIGN') && authExtend.isInRole('DOCUMENT SIGN')) {
                            return alerts.confirm(translated.Warning, translated.CheckInCreateVersionConfirmText, translated.Yes, translated.No).then(function (result) {
                                return $scope.sendDocumentToSign(result);
                            }, function (error) {
                                errors.showError(error);
                            });
                        }
                        else {
                            return $scope.sendDocumentToSign(authExtend.isInRole('DOCUMENTVERSION SIGN'));
                        }
                    });
                }

                $scope.sendDocumentToSign = function (crearVersion) {
                    return documentService.signDocument($stateParams.id, $stateParams.file, $scope.file.password, crearVersion).then(function (result) {
                        $scope.cancel();
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.firmarNacion = function () {
                    
                    fileService.SignDocument($stateParams.file, '#/Document/Detail/' + $stateParams.id).then(function (result) {
                        //$window.open(result.value, '_blank'); nueva pestaña
                        $window.location = result.value;
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.load();
            }
        ]);
})();
